import React,{useState,useContext} from 'react';
import realtimeDB from "../../Utils/api";
import styled from "styled-components";
import {Dialog,DialogTitle,DialogContent,DialogActions,Button} from "@material-ui/core";
import Input from '../Input';

const EditCostumer=({customer,open,close})=>
{
    const {id,data}=customer;
    const {name,dinersCount,note,phone}=data;

    const [Nombre, setNombre] = useState(name);
    const [Cantidad, setCantidad] = useState(dinersCount);
    const [Nota, setNota] = useState(note);
    const [Telefono, setTelefono] = useState(phone);

    const handleEdit=async()=>
    {
        const newData=
        {
            name:Nombre,
            dinersCount:Cantidad,
            note:Nota,
            phone:Telefono
        }

        await realtimeDB.ref("/Customers").child(id).update(newData);
        close();
    }

    let ButtonDisabled=(Nombre==="" || Cantidad==="" || Number(Cantidad)<=0 || Telefono==="" || String(Telefono).length!==13);

    return <Dialog open={open} onClose={close}>
        <DialogTitle style={{textAlign:"center"}}>{`Editar ${name}`}</DialogTitle>
        <DialogContent>
            <div style={{margin:"10px"}}>
            <Input label="Nombre" value={Nombre} changeValue={setNombre}/>
            <Input label="Teléfono" value={Telefono} changeValue={setTelefono}/>
            </div>
            <div style={{margin:"10px"}}>
            <Input type="number" label="Cantidad" value={Cantidad} changeValue={setCantidad} />
            <Input label="Nota"     value={Nota} changeValue={setNota} />
            </div>
        </DialogContent>
        <DialogActions>
            <Button color="primary" variant="outlined" onClick={close}>Cancelar</Button>
            <Button disabled={ButtonDisabled} color="primary" variant="contained" onClick={handleEdit}>Confirmar</Button>
        </DialogActions>
    </Dialog>
}

export default EditCostumer;